import styled, {css, DefaultTheme} from 'styled-components'
import {UserExtended} from '@/features/users/types.ts'

const getStatusColor = (status1: UserExtended['status1'], palette: DefaultTheme['palette']) => {
    const statusToColors = {
        absent: palette.orange['500'],
        candidate: palette.primary['500'],
        suspended: palette.red['500'],
        terminated: palette.neutral['400'],
        operative: palette.green['500']
    } as const satisfies Record<UserExtended['status1'], string>

    return statusToColors[status1]
}

export const StyledStatusBullet = styled.span<{$status: UserExtended['status1']}>(
    ({theme: {palette, opacities}, $status}) => css`
        width: 8px;
        height: 8px;
        border-radius: 2px;
        border: 1px solid ${palette.neutral.black}${opacities['10']};
        background-color: ${getStatusColor($status, palette)};
    `
)
